// Pure, locale-aware list formatter (contract 04 §5, §16). Greenfield — no legacy counterpart.
// Delegates to `Intl.ListFormat` so the conjunction/disjunction word and separators follow the
// locale: `formatList(['a','b','c'], 'en-US')` → `"a, b, and c"`, `(…, 'de-DE')` → `"a, b und c"`,
// `(…, 'en-US', { type: 'disjunction' })` → `"a, b, or c"`. An empty or nullish list returns the `'-'`
// sentinel. Zero Vue, zero Pinia, zero network.

import { FALLBACK_LOCALE, SENTINEL, safeLocale } from './createFormatter'
import type { FormatListOptions } from './types'

const cache = new Map<string, Intl.ListFormat>()
function getListFormat(
  locale: string,
  type: NonNullable<FormatListOptions['type']>,
): Intl.ListFormat {
  const tag = safeLocale(locale)
  const key = `${tag}|${type}`
  const cached = cache.get(key)
  if (cached) return cached

  let lf: Intl.ListFormat
  try {
    lf = new Intl.ListFormat(tag, { style: 'long', type })
  } catch {
    lf = new Intl.ListFormat(FALLBACK_LOCALE, { style: 'long', type })
  }
  cache.set(key, lf)
  return lf
}

export function formatList(
  items: readonly string[] | null | undefined,
  locale: string,
  options: FormatListOptions = {},
): string {
  if (items == null || items.length === 0) return SENTINEL
  return getListFormat(locale, options.type ?? 'conjunction').format(items)
}
